// https://mui.com/material-ui/guides/routing/
import React from 'react';
import {Link as RouterLink, LinkProps as RouterLinkProps} from 'react-router-dom';

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & {href: RouterLinkProps['to']}
>((props, ref) => {
  const {href, ...other} = props;
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});
LinkBehavior.displayName = 'LinkBehavior';
export default LinkBehavior;
